import * as React from "react"
import TextInput, { ITextInputProps } from "../components/TextInput"
import { isRequired, onlyAlphanumeric, checkShortSgId, checkSize } from "../utils/validators"
import { noSymbolFilter } from "../utils/index"
import PrimaryButton from "../components/PrimaryButton"
import { ReducerState } from "AppTypes"
import { useSelector, useDispatch } from "react-redux"
import { appActions, userInfoActions } from "../actions"
import getStepConfig from "./stepConfig"
import api from "../utils/api"
import { updateLanguageAATagging, updateAATagging } from "../utils/aatagging"

const Parent: React.FC = () => {
    const dispatch = useDispatch()
    const { userInfo, activeCountry, parentInfo, isCallingApi, langPack } = useSelector((store: ReducerState) => ({
        userInfo: store.userInfo,
        activeCountry: store.userInfo.activeCountry,
        parentInfo: store.userInfo.parentInfo || {},
        isCallingApi: store.app.isCallingApi,
        langPack: store.config.langPack,
        lang: store.config.lang,
    }))
    const { minAge } = useSelector((store: ReducerState) => store.config.appConfig.countryConfig[activeCountry] || { minAge: 18 })

    const cluster: ITextInputProps["cluster"] = {}

    const nextStepHandler = async () => {
        let isAllValid = true
        for (let key in cluster) {
            if (!cluster[key]()) isAllValid = false
        }
        if (isAllValid) {
            const response = await api.updateApplication(userInfo)
            if (response && response.status === 200) {
                const { nextStep } = getStepConfig()
                dispatch(appActions.gotoStep(nextStep))

                // AA Tracking
                const AALang = updateLanguageAATagging(langPack["lang"])
                updateAATagging({
                    "event_name": "generic_form_complete_step5",
                    "form_name": "UOB PoY",
                    "step_name": "parent_guardian_info",
                    "language": AALang,
                    "country": userInfo.activeCountry.toLowerCase()
                }, "other_form_step")
            }

        }
    }

    const handleUpdateUserInfo: ITextInputProps["onValidation"] = (validation) => {
        const { isValid, inputId, value } = validation

        if (isValid) {
            dispatch(userInfoActions.updateParentInfo({ [inputId as "name" | "id"]: value }))
        } else {
            dispatch(userInfoActions.updateParentInfo({ [inputId]: "" }))
        }
    }

    return (
        <React.Fragment>
            <div className="content content--form">
                <div>
                    <h2 className="app-title">{langPack["parentInformation"].replace("{minAge}", String(minAge))}</h2>
                </div>
                <TextInput
                    inputLabel={langPack["labelFullNameParent"]}
                    initValue={parentInfo.name}
                    inputId={"name"}
                    validators={[isRequired]}
                    cluster={cluster}
                    onValidation={handleUpdateUserInfo}
                    typingHandler={noSymbolFilter}
                />
                {
                    activeCountry === "SG" ?
                        <TextInput
                            inputLabel={langPack["labelIdentityParentSG"]}
                            initValue={parentInfo.id}
                            inputId={"id"}
                            upperCase
                            validators={[isRequired, onlyAlphanumeric, checkShortSgId]}
                            cluster={cluster}
                            onValidation={handleUpdateUserInfo}
                            maxLength={5}
                        /> :
                        <TextInput                            
                            inputLabel={langPack["labelIdentityParentOther"]}
                            initValue={parentInfo.id}
                            inputId={"id"}
                            upperCase
                            validators={[
                                isRequired,
                                onlyAlphanumeric,
                                checkSize(10),
                            ]}
                            cluster={cluster}
                            onValidation={handleUpdateUserInfo}
                            maxLength={10}                                        
                        />
                }
            </div>
            <div className="action">
                {langPack["competitionDisclaimer"] &&
                <>
                <p className="app-disclaimer">{langPack["competitionDisclaimerText"]}</p>
                <br />
                </> 
                }
                <PrimaryButton
                    text={langPack["buttonNext"]}
                    onClick={nextStepHandler}
                    disabled={isCallingApi}
                />
            </div>

        </React.Fragment>
    )
}

export default Parent
